export const Userdata = [
    {
      Id:1,
      name: "Seeking Truth",
      logoimage:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTS0phVj_II0bh3FgSdhXTW8yk33he0Oo2RvloUcqmny6b_tcIePtgKHj4nuuq0wJ3Uhy0&usqp=CAU",
      Question:
        "How do I become more witty, especially in responding to offensive or rude comments?",
      Answer:
        "A guide for you to deal with unthoughtful comments and establish firm boundaries with people in a subtle yet assertive way.",
      image:
        "https://qph.cf2.quoracdn.net/main-qimg-43d6d57e0d3f7d4fb30b2247fef3933c-lq",
        
    },
    {
      Id:2,
      name: "Living Relation",
      logoimage:
        "https://akm-img-a-in.tosshub.com/indiatoday/images/story/202210/sidharth-malhotra-exclusive_1-three_four.jpg?VersionId=WIxY27jOtO6dd6UrYdl8m4nTtjPTbcdx",
      Question: " Sidharth Malhotra REACTS to the big marriage questions?",
      Answer:
        " Sidharth and Kiara have reportedly decided to get married in Chandigarh. A few weeks ago, the two were spotted visiting Manish Malhotra's house and it made their fans speculate that the wedding preparations have finally begun.",
      image:
        " https://www.pinkvilla.com/english/images/2022/11/2129592829_screenshot_2022-11-02-20-20-47-49_1c337646f29875672b5a61192b9010f9_640*360.jpg",
      
      },
    {
      Id:3,
      name: "Quora Sessions ",
      logoimage:
        "https://www.ufpb.br/ufpb/icons/redes-sociais/quora.png/@@images/image.png ",
      Question: " Explore how your business can grow with Quora.?",
      Answer:
        " Businesses come to Quora to highlight their position as an industry thought leader, drive traffic back to their website, and build valuable relationships with customers. .",
      image:
        " https://quora4biz.b-cdn.net/wp-content/uploads/2022/07/HeroGraphic_A.png",
       
    },
    {
      Id:4,
      name: "Quora Sessions ",
      logoimage:
        " https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHUdjrldofdIJ5w5dB7oC2rTKqdtS6fTesc7jOmPqJl2RbMzmJ4j-IIRMyrZxcZgHJhkQ&usqp=CAU ",
      Question: "  What is the study in science?",
      Answer:
        " The Sciences are generally divided into three academic fields: Biology, Chemistry and Physics. Biologists study living things from plants to people, Chemists study the properties of substances and how they react with each other and Physicists are concerned with studying forces in the universe .",
      image:
        "https://science.nasa.gov/files/styles/front_page_hero_image/public/thumbnails/image/07.21_SciencebytheNumbers.JPG?itok=wDSsuGwC",
         
      },
  ];

  